module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map",
    class: [_vm.bemIf(_vm.mapViewIsInitted, 'is-initted')]
  }, [_c('div', {
    staticClass: "map--wrap"
  }, [_c('div', {
    ref: "map",
    staticClass: "map--root"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9c745246", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c745246","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/map/index.vue
// module id = 572
// module chunks = 7